import { render, staticRenderFns } from "./FileListInfo.vue?vue&type=template&id=19147760&scoped=true"
import script from "./FileListInfo.vue?vue&type=script&lang=js"
export * from "./FileListInfo.vue?vue&type=script&lang=js"
import style0 from "./FileListInfo.vue?vue&type=style&index=0&id=19147760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19147760",
  null
  
)

export default component.exports